var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNextTrip = function SvgNextTrip(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.39 417.68C294.078 417.68 335.98 375.778 335.98 324.09C335.98 272.402 294.078 230.5 242.39 230.5C190.702 230.5 148.8 272.402 148.8 324.09C148.8 375.778 190.702 417.68 242.39 417.68Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.48 275.06V330.72H207.42",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.25 431.35C334.68 413.68 361.23 383.45 372.14 349.99C383.05 316.54 383.24 280.15 376.12 245.69C369.03 211.36 350.05 178.03 326.53 152.05C307.59 131.13 283.22 115.42 265.49 93.44C256.05 81.74 248.84 67.77 247.52 52.8C241.87 63.42 237.79 75.07 237.31 87.09C236.7 102.54 243.62 115.96 251.86 128.48C256.97 136.25 263.28 143.4 266.45 152.14C271.57 166.28 267.73 182.73 255.09 191.3C249.35 195.19 242.11 197.44 235.39 195.71C225.99 193.28 219.95 183.67 218.35 174.09C216.75 164.51 218.62 154.75 219.75 145.11C220.87 135.47 219.02 130.37 214.59 121.74C210.93 138.99 196.85 151.77 183.8 163.64C160.74 184.63 138.06 207.25 123.31 235.05C107.84 264.2 104.91 300.64 111.58 332.68C117.3 360.1 129.85 389.12 148.8 409.74",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.98 426.35C185.95 437.11 203.12 443.22 220.58 445.72C238.03 448.23 255.82 447.28 273.31 445",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNextTrip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/next-trip.svg";